interface SubheadingProps {
  text: string;
  className?: string;
}

function Subheading({ text, className = "" }: SubheadingProps) {
  return (
    <h3
      className={`normal-case tracking-wider text-center font-normal ${className}`}
    >
      {text}
    </h3>
  );
}

export default Subheading;
